import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _Times;

const _excluded = ["onClick"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Times } from '@resultadosdigitais/tangram-react-icons';
import useEventCallback from '@restart/hooks/useEventCallback';
import IconButton from '../IconButton';
import { SIZES } from '../helper';

const resolveSpacing = size => {
  const spacing = {
    lg: {
      top: 'var(--size-spacing-05)',
      right: 'var(--size-spacing-05)'
    },
    md: {
      top: 'var(--size-spacing-02)',
      right: 'var(--size-spacing-04)'
    },
    sm: {
      top: 'var(--size-spacing-03)',
      right: 'var(--size-spacing-03)'
    }
  };
  return spacing[size] ? spacing[size] : spacing.lg;
};

const Root = styled.div.withConfig({
  displayName: "MessageClose__Root",
  componentId: "sc-2geva6-0"
})(["position:absolute;", ""], _ref => {
  let {
    size
  } = _ref;
  const spacing = resolveSpacing(size);
  return css(["top:", ";right:", ";"], spacing.top, spacing.right);
});
const MessageClose = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    onClick
  } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  const callbackOnClick = useEventCallback(event => onClick(event));
  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(IconButton, {
    kind: IconButton.kinds.neutral,
    onClick: callbackOnClick,
    size: IconButton.sizes.sm
  }, _Times || (_Times = /*#__PURE__*/React.createElement(Times, {
    title: "Close Icon",
    titleId: "idCloseIcon"
  }))));
});
MessageClose.display = 'MessageClose';
MessageClose.Style = Root;
MessageClose.defaultProps = {
  onClick: () => {},
  size: SIZES.LG
};
process.env.NODE_ENV !== "production" ? MessageClose.propTypes = {
  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   * Set internally by Toast or Snackbar Component
   */
  size: PropTypes.oneOf([SIZES.SM, SIZES.MD, SIZES.LG])
} : void 0;
export default MessageClose;